import React from 'react';
import { Navbar } from '../../layout/Navbar';
import { useSidebar } from '../../../hooks/mostrarSidebar.hook';
import { Sidebar } from '../../layout/Sidebar';
import RoutesWithNotFound from '../../../util/routesWithNotFound';
import { Navigate, Route } from 'react-router-dom';
import { RutasPrivadas } from '../../../routes/rutasPrivadas/rutasPrivadas';
import { HomeScreen } from './HomeScreen';
import { DatosUsuariosView } from './Usuarios/DatosUsuarioView';
import { UsuariosScreen } from './Usuarios/UsuariosScreen';
import { NuevosUsuariosScreen } from './Usuarios/NuevosUsuariosScreen';
import { EmpresasScreen } from './Empresas/EmpresasScreen';

const Private: React.FC  = () => {
	const mostrarSidebar = useSidebar();

	return (
		<div className='overflow-hidden h-screen'>
			<Navbar toggleSidebar={mostrarSidebar.toggleSidebar}/>
			<div className='flex overflow-x-hidden overflow-y-auto'>
				<Sidebar isSidebarOpen={mostrarSidebar.isSidebarOpen}/>
				<div className='overflow-y-auto h-screen w-screen bg-slate-100 p-5'>
					<RoutesWithNotFound>
						
						<Route path={RutasPrivadas.TODOS_USUARIOS} element={<UsuariosScreen />}/>
						<Route path={RutasPrivadas.NUEVOS_USUARIOS} element={<NuevosUsuariosScreen/>}/>
						<Route path={`${RutasPrivadas.NUEVOS_USUARIOS}/${RutasPrivadas.DATOS_USUARIO}/:idUsuarioElsa/:accion`} element={<DatosUsuariosView />}/>
						<Route path={`${RutasPrivadas.TODOS_USUARIOS}/${RutasPrivadas.DATOS_USUARIO}/:idUsuarioElsa/:accion`} element={<DatosUsuariosView />}/>
						<Route path={RutasPrivadas.EMPRESAS} element={<EmpresasScreen />}/>
					</RoutesWithNotFound>
				</div>
			</div>
		</div>
	);
};

export default Private;
